import React, { useState, useEffect } from "react";
import InitiativesHero from "./InitiativesHero";
import InitiativeFocus from "./InitiativeFocus";
import LogicModel from "./LogicModel";
import SuccessSnapshots from "./SuccessSnapshots";


export default function Home() {

  return (
    <div>
<InitiativesHero />
<InitiativeFocus />
<LogicModel />
<SuccessSnapshots />
    </div>
  );
}
